// extracted by mini-css-extract-plugin
export default {"partners":"partners--LudSO","partner":"partner--GEql6","ynet":"ynet--JruWy","poalim":"poalim--EMjpO","hap":"hap--s2oqt"};